import React, { Fragment, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRightFromBracket,
  faUserCircle,
  faCertificate,
  faBarChart,
  faBook,
  faIdBadge,
  faSearch,
  faStore,
  faFire,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Menu, Transition } from '@headlessui/react';
import { logout } from '../../../redux/actions/authentication';
import { getXanoAuthToken } from '../../../redux/actions/authentication';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';
import { useCookies } from 'react-cookie';
import { setLocation } from '../../../redux/actions/location';
import {
  locationWithPermission,
  locationWithoutPermission,
} from '../../../redux/actions/location';
import { locationCheck } from '../../../utils/locationCheck';
import LoginModal from './LoginModal'
import { IKImage } from 'imagekitio-react';
import { useEffect } from 'react';
import { getEpsScoreData } from '../../../redux/actions/jobEligibilityScore';
import { setEpsData } from '../../../redux/actions/userActivity';
import { CircularProgressbar, buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { SET_BLACK_OVERLAY, SET_USER_MODAL } from '../../../redux/actions/types';

const NavBarRight = ({ userLoggedIn, setSearchBtn, searchBtn }) => {
  const location = useLocation();
  const email = useSelector((store) => store?.profileDetails?.email);
  const first_name = useSelector((store) => store?.profileDetails?.first_name);
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const [searchParams , setSearchParams] = useSearchParams();
  const profile_image = useSelector(
    (store) => store?.profileDetails?.profile_image
  );
  const user_college = useSelector(
    (store) => store?.profileDetails?.user_college
  );
  const user_coins = useSelector(
    (store) => store?.profileDetails?.user_coins_data?.[0]
  );
  const user_id = useSelector(
    (store) => store?.profileDetails?.id
  );

  const epsData = useSelector(store => store?.userActivity?.eps_score)


  const userLocation = useSelector((store) => store?.location);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  const isEpsCalculated = useSelector((store) => store?.userActivity?.eps_score?.is_eps_calculated) || false;
  const isDarkOverlay = useSelector((store)=> store?.appTheme?.blackOverlay);
  const [isLoginModal, setIsLoginModal] = useState(false);
  const regex = /^.*\/.*\/.*\/.*\/\d+$/

  useEffect(() => {
    if(searchParams?.get("isLoginModalOpen")==="true")
    {
      setIsLoginModal(true);
    }
    if (user_id && !isEpsCalculated && !regex.test(location.pathname)) {
      console.log("run")
      dispatch(getEpsScoreData(user_id, successObj => {
        console.log({ successObj })
        setEpsData(successObj)
      }))
    }
  }, [user_id, isEpsCalculated])

  const getLocation = async (userId) => {
    const result = await locationCheck(userId);
    //console.log(result);
    if (result === true) {
      //console.log('calllleddd')
      dispatch(setLocation(userId));
    } else {
      //console.log('GOOOO' );
      dispatch(locationWithoutPermission(userId));
      const successCallback = async (data) => {
        const latitude = data.coords.latitude;
        const longitude = data.coords.longitude;

        dispatch(locationWithPermission(userId, latitude, longitude));
      };

      setTimeout(() => {
        navigator.geolocation.getCurrentPosition(
          successCallback,
          (error) => { }
        );
      }, 3000);
    }
  };

  function logoutHandler() {
    dispatch(logout());
    removeCookie('authToken', { path: '/' });
    navigate('/courses');
    dispatch({type: SET_BLACK_OVERLAY , payload : ({...isDarkOverlay , is_closed : true , showModal : false})})
  }

  const profileItems = [
    {
      name: 'My Profile',
      link: '/my-profile/user',
      icon: faUserCircle,
    },
    {
      name: 'My Certificates',
      link: '/my-profile/user/certificates',
      icon: faCertificate,
    },
    {
      name: 'My Personalised Courses',
      link: '/my-profile/user/personalize',
      icon: faFire,
    },
    {
      name: 'My Analytics',
      link: '/my-profile/user/user-analytics',
      icon: faBarChart,
    },
    {
      name: 'My Learnings',
      link: '/my-profile/user/learnings',
      icon: faBook,
    },
    {
      name:'My Roadmaps',
      link:'/my-profile/user/roadmap',
      icon:faStore,
    },
    {
      name: 'My Referrals',
      link: '/my-profile/user/referrals',
      icon: faIdBadge,
    },
    {
      name: 'Market Place',
      link: '/market-place',
      icon: faStore,
    },
  ];

  async function authResponse(response) {
    if (response.error || (response.status && response.status === 'unknown')) {
      console.log('Auth Failed: ', response.error);
    } else {
      const tokenID = response?.tokenObj?.access_token;

      await dispatch(
        getXanoAuthToken(tokenID, (successObj) => {
          const userId = successObj?.user_coins_data?.[0]?.user_id;

          getLocation(userId);

          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
            distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
            $first_name: successObj?.first_name,
            $last_name: successObj?.last_name,
          });
          if (successObj.number_verification) {
            navigate(
              location?.state?.from?.pathname
                ? location?.state?.from?.pathname
                : '/courses',
              { replace: true }
            );
          } else {
            // ReactPixel.trackSingle('333999584825866', 'Lead');
            navigate('/verification', { replace: true });
          }
        })
      );
    }
  }

  const handleCoinsClick = (e) => {
    navigate('/pricing?type=coin');
  };

  return (
    <div className="mr-1 flex items-center justify-between gap-1 sm:gap-4 md:mr-2">
      {window.innerWidth > 768 ? <div
        className={`flex cursor-pointer items-center self-center rounded-full p-1.5 px-1 md:hidden ${searchBtn ? 'bg-teal-400 text-white' : 'bg-slate-200 text-gray-500'
          }`}
        onClick={() => setSearchBtn(!searchBtn)}
      >
        <FontAwesomeIcon icon={faSearch} size="xs" />
        <p className="ml-1 text-[10px] font-semibold">Search</p>
      </div>
        :
      <div
        className={`flex cursor-pointer items-center mr-1 self-center rounded-full p-1.5 px-1 md:hidden ${searchBtn ? 'bg-teal-400 text-white' : ' text-gray-500'
          }`}
        onClick={() => setSearchBtn(!searchBtn)}
      >
        <FontAwesomeIcon icon={faSearch} size="lg" />
      </div>}

      {userLoggedIn ? (
        <>
          <div className="flex items-center justify-between">
          <div
            className="flex cursor-pointer items-center justify-between hover:shadow border-2 py-1 px-1 md:px-2 mr-1 md:mr-2 rounded border-[#F7AA29] "
            onClick={() => {
              navigate('/pricing?type=annual');
            }}
          >
            <img
              className="h-[20px] w-[20px] md:h-[24px] md:w-[24px] mr-1"
              alt="crown icon"
              src="https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
            />

            <span className='text-[#FFC309] text-[12px] md:text-[16px] font-bold'>Upgrade</span>
            
          </div>
            <div
              onClick={handleCoinsClick}
              className=" mx-1 flex flex-col md:flex-row cursor-pointer items-center justify-between font-bold  p-1 text-supertiny text-amber-500 md:mx-2  md:text-sm"
            >
              {/* <FontAwesomeIcon icon={faCoins} size={"lg"} className={"ml-1"} /> */}
              <object
                type="image/svg+xml"
                data={`https://assets.learntube.ai/files/Optimized_folder/marketplace-icons/coins.svg?updatedAt=1688368699188`}
                className="mr-1 h-[20px] w-[20px] md:h-6 md:w-6 pointer-events-none"
              ></object>
              {user_coins?.['available-coins']}
            </div>
            {user_college && (
              <div className="mx-1 flex items-center justify-between text-supertiny text-gray-500 md:mx-2 md:text-sm">
                {user_college?.coin_quota?.current_coins}
                <object
                  type="image/svg+xml"
                  data={`https://assets.learntube.ai/files/Optimized_folder/marketplace-icons/coins.svg?updatedAt=1688368699188`}
                  className="ml-1 h-3 w-3 grayscale md:h-6 md:w-6"
                ></object>
              </div>
            )}
            {/* <NotificationBell className="cursor-pointer text-slate-600 md:ml-4 ml-2 hidden md:block" size="xl" /> */}
          </div>
        </>
      ) : (
        <>
          <div
            className="flex cursor-pointer items-center justify-between mr-2"
            onClick={() => {
              navigate('/pricing?type=annual');
            }}
          >
            <img
              className="md:h-8 md:w-8"
              alt="crown icon"
              src="https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
            />
          </div>
          <button className="inline-block px-2 py-1 md:px-6 md:py-1.5 rounded border-2 font-bold text-teal-600  border-teal-600 text-xs md:text-lg shadow-md hover:shadow-lg hover:text-white hover:bg-teal-600 focus:shadow-lg focus:outline-none focus:ring-0 active:text-black active:bg-white active:shadow-lg transition duration-150 ease-in-out"
            onClick={(event) => setIsLoginModal(!isLoginModal)}>Login </button>{' '}
        </>
      )}
      {
        isLoginModal && <LoginModal isModalEnabled={isLoginModal} setIsModalEnabled={setIsLoginModal} />
      }
      {userLoggedIn && window.innerWidth > 768 ?
        (epsData && epsData.calculated_eps_score > 0 && epsData?.is_visible) ?
          <div className='cursor-pointer w-[3.5rem] h-[3.5rem] flex justify-center items-center ' onClick={() => {
            Mixpanel.track(Constants.Mixpanel.JES_ENTRY_NAVBAR_ICON, {
              distinct_id: email,
            });
            navigate('/my-profile/user')
          }}>
            <p className='text-supertiny my-0 mr-1 text-teal-500 font-bold'>{epsData?.calculated_eps_score}%</p>
            <CircularProgressbarWithChildren
              value={parseInt(epsData?.calculated_eps_score)}
              strokeWidth={8}
              styles={buildStyles({
                pathTransitionDuration: 0.5,
                // Colors
                pathColor: `#F59E0B`,
                textColor: 'white',
                trailColor: 'white',
              })}>
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src='https://assets.learntube.ai/files/Profile-section/thumbUp.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666696717785'
                className="w-6 h-6 md:w-8 md:h-8"
                transformation={[{
                  "height": "50",
                  "width": "50",
                }]}
              />
            </CircularProgressbarWithChildren>
          </div>
          :
          <div className='relative cursor-pointer' onClick={() => {
            Mixpanel.track(Constants.Mixpanel.JES_ENTRY_NAVBAR_ICON, {
              distinct_id: email,
            });
            navigate('/my-profile/user')
          }}>
            <img
              urlEndpoint="https://assets.learntube.ai/files/"
              src='https://assets.learntube.ai/files/Profile-section/thumbUp.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666696717785'
              className="w-6 h-6 md:w-8 md:h-8"
              transformation={[{
                "height": "50",
                "width": "50",
              }]}
            />
            <p className='w-2 h-2 bg-red-500 rounded-full absolute top-0 -right-1'></p>
          </div>
        :
        null
      }

      {userLoggedIn && (
        <div className="flex items-center justify-center md:ml-2"  onClickCapture={(e) => setSearchBtn(false)}>
          <p className="mr-2 text-center text-xs font-bold text-teal-500 md:text-base hidden lg:block">
            {user_name?.split(" ")?.[0]}
          </p>
          <Menu
            as="div"
            className="relative inline-block items-center text-left"

          >
            <Menu.Button>
              {profile_image ? (
                <div className='flex flex-col justify-center items-center ml-1 md:ml-0' >
                  <img
                    src={profile_image}
                    alt="profile image"
                    className="mt-2 h-5 w-5 md:h-7 md:w-7 rounded-full"
                  />
                  <span className=' text-center text-xs font-bold text-teal-500 md:text-base lg:hidden'>{user_name?.split(" ")?.[0]}</span>
                </div>
              ) : (
                <div className='flex flex-col justify-center items-center ml-1 md:ml-0'>
                  <FontAwesomeIcon
                  className="mr-1 text-slate-600"
                  size="xl"
                  icon={faUserCircle}/>
                  <span className=' text-center text-xs font-bold text-teal-500 md:text-base lg:hidden'>{user_name?.split(" ")?.[0]}</span>
                </div>

              )}
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-72 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="z-[99999] flex flex-col items-center justify-between px-1 py-1 shadow-2xl">
                  <div className="flex w-full items-center justify-evenly">
                    <Menu.Item className="my-4 h-12 w-12 rounded-full">
                      {profile_image ? (
                        ({ active }) => <img src={profile_image} alt="profile image" />
                      ) : (
                        <FontAwesomeIcon
                          className="text-slate-600"
                          icon={faUserCircle}
                        />
                      )}
                    </Menu.Item>
                    <Menu.Item className="text-xl font-bold text-cn_green">
                      {({ active }) => <h5>{user_name}</h5>}
                    </Menu.Item>
                  </div>
                  {profileItems.map((item) => (
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          className={`flex w-full py-2 px-4 text-left text-slate-700 hover:bg-slate-100`}
                          onClick={() => {
                            // setSearchBtn(false);
                            navigate(item.link);
                          }}
                        >
                          <FontAwesomeIcon
                            className="mr-4"
                            icon={item.icon}
                            size="lg"
                          />
                          <p className="font-bold">{item.name}</p>
                          {item.name === 'Market Place' && (
                            <h5 className="rounded-full bg-gradient-to-tr from-red-500 to-red-800 px-1 text-supertiny font-bold text-white">
                              NEW
                            </h5>
                          )}
                        </button>
                      )}
                    </Menu.Item>
                  ))}
                  <Menu.Item>
                    <button
                      className={`flex w-full py-2 px-4 text-left text-slate-700 hover:bg-slate-100`}
                      onClick={() => {
                        // setSearchBtn(false);
                        Mixpanel.track(Constants.Mixpanel.JES_ENTRY_MENU_ICON, {
                          distinct_id: email,
                        });
                        navigate("/my-profile/user");
                      }}
                    >
                      <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src='https://assets.learntube.ai/files/Profile-section/thumbUp.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666696717785'
                        className="w-6 h-6 md:w-8 md:h-8 mr-2"
                        transformation={[{
                          "height": "50",
                          "width": "50",
                        }]}
                      />
                      <p className="font-bold">My Job Score</p>
                    </button>

                  </Menu.Item>
                  <hr className="m-0 w-full bg-slate-200" />
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        className={`group my-2 w-full rounded px-2 py-2 text-center font-bold text-slate-400 hover:bg-slate-100`}
                        onClick={logoutHandler}
                      >
                        <FontAwesomeIcon
                          className="mr-1 rotate-180"
                          icon={faRightFromBracket}
                        />
                        Logout
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      )}
    </div>
  );
};

export default NavBarRight;
